module.exports = __webpack_public_path__ + "img/EZD_20220514_2.ead1d887.png";